// Auto-generated skeleton for CraftsmanTaskStatus

import { CraftsmanTaskStatusText } from "./CraftsmanTaskStatusText";

export const CraftsmanTaskStatus: Api.CraftsmanTaskStatus = {
  id: 0,
  hp_id: null,
  name: '',
  text: CraftsmanTaskStatusText,
  created: null,
  updated: null,
};

